export default __webpack_public_path__ + "static/media/vk-logo-transparent-white.167e641c.png";